import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionActions from '@material-ui/core/AccordionActions';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Form, Field } from 'react-final-form';
import { makeStyles } from '@material-ui/core/styles';
import _debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import AutocompleteFieldAdapter from 'components/shared/AutocompleteFieldAdapter';
import SelectFieldAdapter from 'components/shared/SelectFieldAdapter';
import { materialActions } from 'store/modules/material';
import { debounceWait } from 'common/constants';
import { filtersPagination } from 'common/filters';

const useStyles = makeStyles((theme) => ({
  form: {
    marginTop: theme.spacing(3),
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const MaterialFilters = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const {
    initialValues,
    loading,
    materialOptions,
    materialLoading,
    materialTypeOptions,
  } = useSelector((state) => ({
    initialValues: state.material.filters,
    loading: state.material.loading.list,
    materialOptions: state.material.options,
    materialLoading: state.material.loading.filter,
    materialTypeOptions: state.materialType.options,
  }));

  const onMaterialIdChange = (event, value, reason) => {
    if (reason === 'input' && value.length >= 2) {
      const toExclude = initialValues.id.length > 0
        ? initialValues.id.map((item) => item.value)
        : [];

      dispatch(materialActions.getFilterOptions({
        value, exclude: toExclude, pagination: filtersPagination,
      }));
    }
  };

  const onSubmit = (values) => {
    dispatch(materialActions.updateFilters(values));
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={onSubmit}
      render={({ handleSubmit, pristine }) => (
        <form
          onSubmit={handleSubmit}
          className={classes.form}
        >
          <Accordion square defaultExpanded={isOpen}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>Filtros</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    id="id-filter"
                    name="id"
                    component={AutocompleteFieldAdapter}
                    options={materialOptions}
                    isMultiple
                    filterSelectedOptions
                    loading={materialLoading}
                    onInputChange={_debounce(onMaterialIdChange, debounceWait)}
                    textProps={{
                      label: 'Nombre',
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    id="material_type_id-filter"
                    name="material_type_id"
                    component={SelectFieldAdapter}
                    options={materialTypeOptions}
                    label="Tipo"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
            <Divider />
            <AccordionActions>
              <Button
                type="submit"
                size="small"
                color="primary"
                disabled={pristine || loading}
              >
                Filtrar
              </Button>
            </AccordionActions>
          </Accordion>
        </form>
      )}
    />
  );
};

MaterialFilters.defaultProps = {
  isOpen: false,
};

MaterialFilters.propTypes = {
  isOpen: PropTypes.bool,
};

export default MaterialFilters;
